import ImpactShareButtons from "components/account/ImpactShareButtons";
import Separator from 'components/Separator';
import Link from 'next/link';
import { ASSET_PREFIX, colors } from "utils/constants";

const MyImpactAccountSection = ({ treesPlanted }: { treesPlanted: number }) => {
  return (
    <div className="myImpactAccountSection fullWidth flexCentered">
      <div className="treesPlantedSection fullWidth flexCentered">
        <p className="outlineText">{treesPlanted.toLocaleString()}</p>

        <p
          style={{
            textTransform: 'uppercase',
            margin: '0.2em',
            fontSize: '1.2em',
            fontWeight: 800,
          }}
        >
          Tree{treesPlanted === 1 ? '' : 's'} planted
        </p>
      </div>

      <Separator style={{ marginTop: 0 }} />

      <div
        className="shareButtons"
        style={{ maxWidth: '300px' }}
      >
        <p style={{ fontStyle: 'italic' }}>And that's worth shouting about!</p>

        <ImpactShareButtons />
      </div>

      <Separator />

      <p>
        Your trees have helped change the planet and people’s lives for the
        better!{' '}
        <Link href="/giving-back">
          <a style={{ textDecoration: 'underline' }}>See how</a>
        </Link>
      </p>

      <style jsx>{`
        .myImpactAccountSection {
          text-align: center;
          padding: 1em 0 1.5em;
        }

        .treesPlantedSection {
          text-shadow: 0 0 1px ${colors.trees.primary};
          background-color: deeppink;
          background: url(${ASSET_PREFIX}/images/trees-background.svg);
          background-size: auto 100%;
          background-position: 0% 1px;
          min-height: 100px;
        }

        .outlineText {
          -webkit-text-fill-color: #ffffff99;
          -webkit-text-stroke-width: 2.5px;
          -webkit-text-stroke-color: ${colors.primaryBrandGray};
          text-shadow: 0 0 3px ${colors.trees.primary};
          font-size: 3em;
          font-weight: 900;
          margin: 0;
        }

        :global(.myImpactAccountSection .separator) {
          margin: 2em 0;
        }
      `}</style>
    </div>
  );
};

export default MyImpactAccountSection;
